import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative px-0 py-10 lg:p-10 w-full min-h-screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "block lg:hidden h-8 mw-40 mb-6",
  src: "/media/logos/logo-full-dark.svg",
  alt: "Logo"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-4xl leading-10 font-extrabold mb-6 lg:mb-10" }, /*#__PURE__*/_toDisplayString('Contacts'), -1)
const _hoisted_4 = { class: "text-xl leading-7 font-medium mb-6" }
const _hoisted_5 = { class: "md:flex flex-wrap" }
const _hoisted_6 = { class: "w-full md:w-1/2 pr-4 md:pr-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "company",
  class: "block text-sm font-medium text-gray-700"
}, " Company ", -1)
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "w-full md:w-1/2 pr-4 md:pr-0 md:pl-2 mt-3 md:mt-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-sm font-medium text-gray-700"
}, " Corporate email ", -1)
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = { class: "w-full md:w-1/2 pr-4 md:pr-2 mt-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "block text-sm font-medium text-gray-700"
}, " Full name ", -1)
const _hoisted_15 = { class: "mt-2" }
const _hoisted_16 = {
  key: 0,
  class: "rounded-md bg-yellow-50 p-4 mt-2"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-yellow-700" }, " Please use your first and last names ")
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "w-full md:w-1/2 pr-4 md:pr-0 md:pl-2 mt-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "block text-sm font-medium text-gray-700"
}, " Phone ", -1)
const _hoisted_21 = { class: "mt-2" }
const _hoisted_22 = { class: "w-full md:w-1/2 pr-4 md:pr-2 mt-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "block text-sm font-medium text-gray-700"
}, " Password ", -1)
const _hoisted_24 = { class: "mt-2" }
const _hoisted_25 = {
  key: 0,
  class: "rounded-md bg-yellow-50 p-4 mt-2"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-yellow-700" }, " Your password must be at least 8 characters including a lower-case letter, an upper-case letter, and a number. ")
], -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "w-full pr-4 mt-5 flex items-start md:items-center" }
const _hoisted_29 = ["checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("form", {
      class: "block p-6 rounded-md shadow-sm bg-white mb-4 max-w-5xl",
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSubmit && _ctx.handleFormSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.formConfig.title), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("input", {
              type: "text",
              name: "company",
              id: "company",
              class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
              value: _ctx.company.name,
              disabled: ""
            }, null, 8, _hoisted_9)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "email",
              id: "email",
              class: _normalizeClass(["focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3", { 'border-red-600': !_ctx.isValidEmail }]),
              placeholder: "blake@janover.co",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formConfig.collectedData.email) = $event))
            }, null, 2), [
              [_vModelText, _ctx.formConfig.collectedData.email]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "firstName",
              id: "firstName",
              class: _normalizeClass(["focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3", { 'border-red-600': !_ctx.isValidName }]),
              placeholder: "Blake Janover",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formConfig.collectedData.name) = $event))
            }, null, 2), [
              [_vModelText, _ctx.formConfig.collectedData.name]
            ])
          ]),
          (_ctx.formConfig.collectedData.name.length > 6 && !_ctx.isValidName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              name: "phone",
              id: "phone",
              class: "focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3",
              placeholder: "+1 (305) 264-43-33",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formConfig.collectedData.phone) = $event)),
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, _ctx.formConfig.collectedData.phone],
              [_directive_maska, '+1 (###) ###-####']
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              type: "password",
              name: "password",
              id: "password",
              class: _normalizeClass(["focus:ring-indigo-500 focus:border-indigo-500 block w-full border rounded-md h-10 w-full text-sm px-3", { 'border-red-600': !_ctx.isValidPassword }]),
              placeholder: "Password",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formConfig.collectedData.password) = $event)),
              autocomplete: "current-password"
            }, null, 2), [
              [_vModelText, _ctx.formConfig.collectedData.password]
            ])
          ]),
          (!_ctx.isValidPassword)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("input", {
            type: "checkbox",
            class: "default:ring-2 mt-1 md:mt-0",
            checked: _ctx.termsAccepted,
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.termsAccepted = !_ctx.termsAccepted))
          }, null, 40, _hoisted_29),
          _createElementVNode("span", {
            class: "text-sm text-gray-900 ml-2 cursor-pointer",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.termsAccepted = !_ctx.termsAccepted))
          }, " Please confirm you work for a direct lender. We are not accepting brokers at this time ")
        ])
      ]),
      _createElementVNode("button", {
        class: _normalizeClass(["h-10 bg-sky text-white rounded-md w-24 mt-6 flex justify-center items-center", { 'pointer-events-none opacity-50': _ctx.isLoading || !_ctx.formIsValid }]),
        type: "submit"
      }, " Submit ", 2)
    ], 32)
  ]))
}